import ItemDetailsContainer from "./../components/ItemDetails";
import { connect } from "react-redux";
import { vehicleAction } from "./../store/actions";

const mapStateToProps = state => {
  const {
    vehicleReducer: {
        getItemDetail,
        getItemDetailError,
        getItemDetailLoader,
        getPromotionalApiDataSuccess,
        getPromotionalApiDataError,
        getPromotionalApiDataLoader,
        getCountriesSuccess,
        getPriceSuccess,
        getStockRecordSuccess,
        addProductToBasketSuccess,
        addProductToBasketError,
        addProductToBasketLoader,
        getShippingMethodsSuccess,
        getShippingMethodsError,
        getShippingMethodsLoader
    },
    authReducer: {
      isLoggedIn
    }
  } = state;
  return {
    getItemDetail,
    getItemDetailError,
    getItemDetailLoader,
    getCountriesSuccess,
    getPromotionalApiDataSuccess,
    getPromotionalApiDataError,
    getPromotionalApiDataLoader,
    getPriceSuccess,
    getStockRecordSuccess,
    addProductToBasketSuccess,
    addProductToBasketError,
    addProductToBasketLoader,
    getShippingMethodsSuccess,
    getShippingMethodsError,
    getShippingMethodsLoader,
    isLoggedIn
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getItem: id =>
      dispatch(vehicleAction.getItem(id)),
    // getCountries: payload =>
    //   dispatch(vehicleAction.getCountries(payload)),
    getPromotionalApiData: payload =>
      dispatch(vehicleAction.getPromotionalApiData(payload)),
    addProductToBasket: payload =>
      dispatch(vehicleAction.addProductToBasket(payload)),
    // getShippingMethods: payload =>
    //   dispatch(vehicleAction.getShippingMethods(payload))
    // sideMenuAction: payload => dispatch(sideMenuAction.setSideMenu(payload))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemDetailsContainer);
